// extracted by mini-css-extract-plugin
export default {"trigger":"InfoTooltip_trigger__c7Nls"};